import React from 'react';
import { RiBankLine } from "react-icons/ri"; // Assurez-vous d'avoir 'react-icons' installé
import transactionData from './transactionData.json';
import './TransactionCard.scss';

const TransactionCard = () => {
    const transaction = transactionData
  return (
    <div className="transaction-card">
      <div className="row">
        <div className="icon"><RiBankLine /></div>
        <div className="text">{transaction.timestamp}</div>
        <div >{transaction.paymentDetails.totalAmount}</div>
      </div>
      <div className="row">
        <div className="empty"></div>
        <div className="status">{transaction.paymentStatus}</div>
      </div>
      <div className="row">
        <div className="amount-small">{transaction.paymentDetails.amount}</div>
        <div className="confirmation">{transaction.paymentDetails.confirmation}</div>
      </div>
      <div className="row">
        <div className="status-description">{transaction.statusDescription}</div>
        <div className="empty"></div>
      </div>
      <div className="row">
        <div className="method">{transaction.paymentDetails.method}</div>
        <button className="action">account</button>
      </div>
      <div className="row">
        <div className="transaction-id-label">Payee account number</div>
        <div className="transaction-id">{transaction.transactionId}</div>
        <div className="empty"></div>
      </div>
    </div>
  );
};

export default TransactionCard;
